import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
const StyledWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: ${props => (props.$isSidebarMode ? 'unset;' : '0.75/1')};
  max-height: ${props => (props.$isSidebarMode ? 'unset;' : '87vh')};
  right: 0;

  border: 0;
  padding: 0;
  background: none;
  cursor: ${props => (props.as === 'button' ? 'pointer' : 'unset')};
`;
const StyledHeadline = styled.h1 `
  position: absolute;
  top: ${SkapaTokens.space150};
  right: ${SkapaTokens.space200};
  z-index: 1;
  color: ${props => props.theme.framework.slideshow.headlineColor};
  font-size: ${SkapaTokens.fontSize500};
  font-weight: ${SkapaTokens.fontWeightBold};
  line-height: 1;
  margin: 0;

  text-align: end;

  @media (min-width: 500px) {
    top: ${SkapaTokens.space200};
    right: ${SkapaTokens.space250};
    font-size: ${SkapaTokens.fontSize700};
  }

  @media (min-width: ${SkapaTokens.breakpointL}) {
    top: ${SkapaTokens.space300};
    right: ${SkapaTokens.space400};
    font-size: ${SkapaTokens.fontSize1100};
  }
`;
const getAnimationKeyframes = (images) => {
    const numberOfImages = images.length;
    /** Because it is hard (impossible?) to create dynamic keyframes in CSS this function will return
     *  the images in order even if the number of images does not match the number of keyframes. */
    const getImageIndexForKeyframe = (keyframeNumber) => {
        return keyframeNumber % numberOfImages;
    };
    return keyframes `
      0% {
          background-image: url(${images[getImageIndexForKeyframe(0)]});
      }
  
      12.5% {
          background-image: url(${images[getImageIndexForKeyframe(1)]});
      }
  
      25% {
          background-image: url(${images[getImageIndexForKeyframe(2)]});
      }
      
      37.5% {
          background-image: url(${images[getImageIndexForKeyframe(3)]});
      }
      
      50% {
          background-image: url(${images[getImageIndexForKeyframe(4)]});
      }
  
      62.5% {
          background-image: url(${images[getImageIndexForKeyframe(5)]});
      }
  
      75% {
          background-image: url(${images[getImageIndexForKeyframe(6)]});
      }
  
      87.5% {
          background-image: url(${images[getImageIndexForKeyframe(7)]});
      } 
  
      100% {
        /* Always end on the first image (0) to avoid UI flashes */
          background-image: url(${images[getImageIndexForKeyframe(0)]});
      } 
  `;
};
const StyledAnimatedImage = styled.div `
  position: absolute;
  max-height: 100%;
  top: 0;
  bottom: 0;
  width: 100%;
  border-radius: ${SkapaTokens.radiusM};

  /** For preloading images */
  background-image: ${props => props.$images.map(img => `url(${img})`).join(',')};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  animation: ${props => getAnimationKeyframes(props.$images)} ${props => props.$animatonDuration}s
    infinite;
  animation-delay: 5s;

  @media (max-aspect-ratio: 10/8) {
    max-height: ${props => (props.$isSidebarMode ? '70vh;' : '100%')};
  }

  /** Apply additional app specific CSS */
  ${props => props.$slideCssOverrides}
`;
export const GuidaSlideshow = ({ onClick, title, images, slideCssOverrides, animationDuration = 30 }) => {
    const { isSidebarMode } = useGuidaUIStates();
    return (_jsxs(StyledWrapper, { "$isSidebarMode": isSidebarMode, onClick: isSidebarMode ? undefined : onClick, as: isSidebarMode ? 'div' : 'button', "data-testid": 'slide-show', children: [_jsx(StyledHeadline, { children: title }), _jsx(StyledAnimatedImage, { "$isSidebarMode": isSidebarMode, "$images": images, "$slideCssOverrides": slideCssOverrides, "$animatonDuration": animationDuration })] }));
};
//# sourceMappingURL=GuidaSlideshow.js.map